import { FETCH_METRICS_BY_IDENTIFIER, CLEAR_METRICS } from '#action/types';

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case FETCH_METRICS_BY_IDENTIFIER:
      return { ...state, [action.identifier]: action.payload };
    case CLEAR_METRICS:
      return defaultState;
    default:
      return state;
  }
};
